import request from '@/utils/request'

/**
 * 2022-02-03 董浩
 * 获取首页轮播
 */
export function getHomeBanner(data) {
	return request({
		url: 'procurement/system/front/subject/subjectWheelPlanting?specialArea=0&type=0'
	})
}

/**
 * 2022-02-03 乔宁
 *  获取领券中心优惠券
 */
export function getCouponCenterList(data) {
	return request({
		url: 'procurement/system/front/sms-activitys/ticket-have-coupon'
	})
}

/**
 * 2022-02-03 乔宁
 * 领取接口
 */
export function getCoupon(data) {
	return request({
		url: 'procurement/system/front/sms-activity-historys/receive-coupon',
		method: 'POST',
		data
	})
}

/**
 * 2022-02-03 乔宁
 *  获取订单可用券
 */
export function availableCoupon(data) {
	return request({
		url: 'procurement/system/front/sms-activitys/available-coupon',
		method: 'POST',
		data
	})
}

/**
 * 2022-02-03 乔宁
 *  获取订单不可用券
 */
export function unAvailableCoupon(data) {
	return request({
		url: 'procurement/system/front/sms-activitys/not-available-coupon',
		method: 'POST',
		data
	})
}

/**
 * 2023年3月28日
 *  企业资质下载
 */
export function getMaterialFiles() {
	return request({
		url: 'procurement/system/front/material-files/pages?type=0',
		method: 'GET'
	})
}

/**
 * 2025-08-28 DH
 * 获取公司经营资质列表
 * */
export function getLicenseImg() {
    let url = 'procurement/system/front/material-files/getListByType?type=1';

    return request({
        url: url,
        method: "GET"
    })
}

/**
 * 2025年7月4日 乔宁
 *  个人中心-我的优惠券
 */
export function userAllCoupon(data) {
	return request({
		url: '/procurement/system/front/sms-activitys/user-all-coupon?size=' + data.size +
			'&current=' + data.current + '&useStatus=' + data.useStatus,
		method: 'POST',
		data
	})
}

/**
 * 2025-07-08 lmy
 * 获取单品优惠券
 * */
export function getProductCoupon(params) {
  return request({
 		url: '/procurement/system/front/sms-activitys/products-available',
 		params
 	})
}